import {
	Component,
	Input,
	OnInit
}                                      from '@angular/core';
import { AbstractModalBase }           from '@core/modal-base/abstractModalBase';
import { ModalIdentifierEnum }         from '@core/modals/modal.model';
import { INVALID_TENANT_MODAL_CONFIG } from '@core/modals/show-invalid-tenant/invalid-tenant-modal.config';
import { NgbActiveModal }              from '@ng-bootstrap/ng-bootstrap';
import { KeycloakService }             from 'keycloak-angular';

@Component( {
	selector: 'app-show-invalid-tenant-modal',
	templateUrl: './show-invalid-tenant-modal.component.html',
	styleUrls: [ './show-invalid-tenant-modal.component.scss' ]
} )
export class ShowInvalidTenantModalComponent extends AbstractModalBase implements OnInit {

	private readonly _modalConfig = INVALID_TENANT_MODAL_CONFIG;

	private readonly _logoutTimer = INVALID_TENANT_MODAL_CONFIG.logoutTimer;

	private readonly _defaultSeconds = 10;

	private _seconds = this._logoutTimer / 1000;

	private _modalIdentifier: ModalIdentifierEnum;

	dots: { fadeOut: boolean }[];

	get modalIdentifier(): ModalIdentifierEnum {
		return this._modalIdentifier;
	}

	@Input() set modalIdentifier( modalIdentifier: ModalIdentifierEnum ) {
		this._modalIdentifier = modalIdentifier;
	}

	constructor(
		private readonly activeModal: NgbActiveModal,
		protected readonly keycloakService: KeycloakService
	) {
		super();
		this.translationPath += `.${ this._modalConfig.translationPath }`;
	}

	ngOnInit() {
		// check for valid timer and set fallback default
		if ( Number.isNaN( this._seconds ) ) {
			this._seconds = this._defaultSeconds;
		}
		// create one dot for each second
		this.dots =
			Array.from( { length: this._seconds - 1 }, () => (
				{ fadeOut: false }
			) );

		const interval = setInterval( () => {
			// fade next time dot
			this._seconds--;
			if ( this._seconds > 0 ) { this.dots[ this._seconds - 1 ].fadeOut = true; }

			// logout after time is up
			if ( !this._seconds || this._seconds === 0 ) {
				clearInterval( interval );

				this.keycloakService.logout()
				.then( () => {
					this.activeModal.close();
				} );
			}
		}, 1000 );
	}

	abort() {}

	confirm() {}
}
